import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import WujieVue from 'wujie-vue3'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useI18nStore } from './store/i18n'

const app = createApp(App)
const pinia = createPinia()

// 初始化顺序：Pinia -> i18n plugin -> 初始化语言
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.use(WujieVue)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局注册自定义图标 — 用法与 Element Plus 图标完全一致
import IconMenuTree from '@/components/icons/IconMenuTree.vue'
import IconShieldKey from '@/components/icons/IconShieldKey.vue'
import IconRobot from '@/components/icons/IconRobot.vue'
import IconLetterS from '@/components/icons/IconLetterS.vue'
app.component('IconMenuTree', IconMenuTree)
app.component('IconShieldKey', IconShieldKey)
app.component('IconRobot', IconRobot)
app.component('IconLetterS', IconLetterS)

// 在 Pinia 和 i18n plugin 注册后初始化语言
const i18nStore = useI18nStore()
i18nStore.initializeLocale()

app.mount('#app')
